class WishlistAdd extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.addToWishlist = this.addToWishlist.bind(this)

    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this, 'click', this.handleSubmit)

    this.listeners.add(this.els.create.element, 'click', this.handleCreate)

    this.populateProductInfo = this.populateProductInfo.bind(this)
    this.populateLists = this.populateLists.bind(this)

    this.handleVariantChange = this.handleVariantChange.bind(this)
    this.listeners.add(this, 'change', this.handleVariantChange)

    this.listeners.add(document, 'checkIsInWishlist', this.checkIsInWishlist)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST,
      this.checkIsInWishlist,
    )

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.checkLoggedIn()

      this.checkIsInWishlist()

      this.externalEls.trigger?.elements.forEach((el) => {
        el.setAttribute('data-wishlist-active', '')
      })
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      (onSuccess) => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  handleClose () {
    this.checkIsInWishlist()

    window.drawers.activeDrawerKey = ''
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-add-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: trigger.dataset.productUrl,
      }

      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      window.drawers.activeDrawerKey = 'drawer-wishlist-add'

      this.setAttribute('data-product-id', trigger.dataset.productId)
      this.setAttribute('data-variant-id', trigger.dataset.variantId)
      this.setAttribute('data-product-url', trigger.dataset.productUrl)

      this.populateProductInfo(
        `${trigger.dataset.productUrl}?variant=${trigger.dataset.variantId}`,
      )

      window._swat.fetchLists({
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    }
  }

  handleVariantChange (event) {
    const variantsChange = event.target.closest(
      '[data-wishlist-add-el="variants-select"]',
    )

    if (!variantsChange) return

    this.setAttribute('data-variant-id', variantsChange.value)
  }

  populateProductInfo (variantUrl) {
    return window.BAO.sectionRenderer
      .fetchSingle('wishlist-product-info', variantUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        if (myself) {
          this.els['product-info'].element.innerHTML = myself.innerHTML
        }
      })
      .catch(() => {
        return null
      })
  }

  populateLists (lists) {
    this.els.lists.element.innerHTML = ''

    lists.forEach((list) => {
      const listImage = list.listcontents[0]?.iu
        ? `<img class="wsh-Card_Image" src="${list.listcontents[0].iu}" alt="${list.lname}">`
        : ''

      this.els.lists.element.innerHTML += `
        <button
          type="button"
          class="drw-WishlistAdd_Item"
          data-list-id="${list.lid}"
          data-wishlist-add-el="submit"
        >
          <span class="drw-WishlistAdd_Image">${listImage}</span>

          <span class="drw-WishlistAdd_Content">
            <span class="drw-WishlistAdd_Title fz-12_120">
              ${list.lname}

              <span class="drw-WishlistAdd_Icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path stroke="currentColor" d="m13.261 13.96-2.912-2.84-.349-.34-.35.34-2.911 2.84a.146.146 0 0 1-.158.027.13.13 0 0 1-.06-.043.13.13 0 0 1-.021-.081V6.137c0-.074.06-.137.14-.137h6.72c.08 0 .14.063.14.137v7.726a.13.13 0 0 1-.021.08.13.13 0 0 1-.06.044.146.146 0 0 1-.158-.027Z"/>
                </svg>
              </span>
            </span>

            <span class="drw-WishlistAdd_Text fz-13_150">${list.cnt} ${list.cnt === 1 ? window.theme.wishlist.item : window.theme.wishlist.items}</span>
          </span>
        </button>
      `
    })

    this.els['lists-header'].element.setAttribute(
      'aria-hidden',
      lists.length === 0,
    )
    this.els.newlist.element.value =
      lists.length === 0 ? window.theme.wishlist.wishlist : ''
  }

  handleSubmit (event) {
    const trigger = event.target.closest('[data-wishlist-add-el="submit"]')

    if (!trigger) return

    const listChoice = trigger.dataset.listId

    this.addToWishlist(listChoice)
  }

  handleCreate () {
    if (this.els.newlist.element.value === '') return

    const listConfig = {
      lname: this.els.newlist.element.value,
    }

    window._swat.createList(
      listConfig,
      (newList) => this.addToWishlist(newList.lid),
      this.wishlistError,
    )
  }

  addToWishlist (lid) {
    const product = {
      epi: parseInt(this.dataset.variantId),
      empi: parseInt(this.dataset.productId),
      du: this.dataset.productUrl,
    }

    window._swat.addToList(lid, product, this.handleClose, this.wishlistError)
  }

  checkIsInWishlist () {
    window._swat.fetchLists({
      callbackFn: (lists) => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )
        this.externalEls.count?.elements.forEach((countEl) => {
          countEl.setAttribute('aria-hidden', productCount === 0)
          countEl.textContent = `(${productCount})`
        })

        this.externalEls.trigger?.elements.forEach((el) => {
          const matchedProduct = lists.find((list) =>
            list.listcontents.find(
              (product) => product.empi === parseInt(el.dataset.productId),
            ),
          )

          if (matchedProduct) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedProduct.lid)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }

          el.setAttribute('data-wishlist-active', '')
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-add')) {
  customElements.define('wishlist-add', WishlistAdd)
}
